import { render, staticRenderFns } from "./personaltzbs.vue?vue&type=template&id=47b57438&scoped=true&"
import script from "./personaltzbs.vue?vue&type=script&lang=js&"
export * from "./personaltzbs.vue?vue&type=script&lang=js&"
import style0 from "./personaltzbs.vue?vue&type=style&index=0&id=47b57438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b57438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b57438')) {
      api.createRecord('47b57438', component.options)
    } else {
      api.reload('47b57438', component.options)
    }
    module.hot.accept("./personaltzbs.vue?vue&type=template&id=47b57438&scoped=true&", function () {
      api.rerender('47b57438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/personaltzbs.vue"
export default component.exports